const { default: axiosInstance } = require("utils/axios");

const getProductsMarketPlace = async (filter) => {
  try {
    const response = await axiosInstance.get("/store/marketplace", {
      params: {
        type: filter.type,
        page: filter.page,
        limit: filter.limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const getMarketplaceProductById = async (id) => {
  try {
    const response = await axiosInstance.get(`/store/marketplace/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const postPurchasePackage = async (data) => {
  try {
    const response = await axiosInstance.post("/manage/purchase-package", data);
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const sendProductToMarketPlace = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/manage/product-marketplace",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error;
  }
};

const MarketPlaceAPI = {
  getProductsMarketPlace,
  getMarketplaceProductById,
  postPurchasePackage,
  sendProductToMarketPlace,
};

export default MarketPlaceAPI;
